'use strict';

import cookieConsent from './cookieConsent';
import videolink from './videolink';
import slickGallery from './slick-gallery';
import swiperGallery from './swiper-gallery';
import animatedFeatures from './animatedFeatures';
import lazyLoad from './lazyLoad';
import initModal from './modal';

document.addEventListener('DOMContentLoaded', () => {
    cookieConsent();
    videolink();
    slickGallery('.gallery:not(.gallery-swiper)');
    swiperGallery('.gallery-swiper');
    animatedFeatures();
    lazyLoad();
    initModal();
});

$(document).ready(function () {

    let scrollOffset = 110;

    //sticky header
    function transformHeader() {
        let scroll = $(window).scrollTop();

        if (scroll > 0) {
            $('.main-header').addClass('sticky');
        } else {
            $('.main-header').removeClass('sticky');
        }
    }
    transformHeader();
    $(window).scroll(function () {
        transformHeader();
    });



    //scroll down on scroll-icon click
    $('.scroll-icon').on( 'click touch', function() {
        let x = $(window).height();
        $('html, body')
            .animate(
                {scrollTop: x},
                500,
                'swing',
                function(){}
            );
    });


    //particles in homepage background
    if ($('#particles-js').length) {
        $.getScript( '/assets/js/particles.min.js', function() {
            particlesJS.load('particles-js', '/assets/js/particles.json');
        });
    }


    //parallax images
    if (ScrollMagic) {
        let controller = new ScrollMagic.Controller();

        //ignore on mobile
        if ($( window ).width() >= 768) {

            let parallaxBuilding = TweenMax
                .to($('#town-parallax > .town-second-layer-bg'), 1, {
                    y: '20%',
                    ease: Linear.easeNone
                })
                .reversed(true);

            new ScrollMagic.Scene({
                triggerElement: this,
                duration: '100%'
            })
                .setTween(parallaxBuilding)
                .addTo(controller);


            let parallaxTitle = TweenMax
                .to($("#town-parallax > .town-second-layer__content"), 1, {
                    y: '-250%',
                    ease: Linear.easeNone
                })
                .reversed(false);

            new ScrollMagic.Scene({
                triggerElement: this,
                duration: '100%'
            })
                .setTween(parallaxTitle)
                .addTo(controller);


            let parallaxTown = TweenMax
                .to($(".town-first-layer-bg"), 1, {
                    y: '-5%',
                    ease: Linear.easeNone
                })
                .reversed(true);

            new ScrollMagic.Scene({
                triggerElement: this,
                duration: '90%'
            })
                .setTween(parallaxTown)
                .addTo(controller);
        }



        $(".parallax").each(function () {
            let parallaxBackground = TweenMax
                .to(jQuery(this).children('.image'), 1, {
                    backgroundPosition: '50% top',
                    ease: Linear.easeNone
                });

            new ScrollMagic.Scene({
                triggerElement: this,
                duration: '200%',
                triggerHook: 'onEnter'
            })
                .setTween(parallaxBackground)
                .addTo(controller);
        });

    }



    //contact form ajax
    let responseContainer = '#contact_form_container';
    let contactForm = $('#contact_form');

    $(contactForm).submit(function(event) {
        event.preventDefault();

        let formData = $(contactForm).serialize();

        $.ajax({
            type: $(contactForm).attr('method') ? $(contactForm).attr('method') : 'POST',
            url: $(contactForm).attr('action'),
            data: formData
        }).done(function() {
            $(responseContainer + ' .success').fadeIn();
            if (fbq) {
                fbq('track', 'Contact');
            }
        }).fail(function() {
            $(responseContainer + ' .error').fadeIn();
        });

    });


    //apartments search form ajax
    let apartmentSearchResultsContainer = $('#apartments-search-result-container');
    let apartmentSearchForm = $('#apartments-search-form');
    let isLoadingMore = false;

    function formatPrice(price) {
        if (!price) return '-';
        const num = parseFloat(price);
        const parts = num.toFixed(2).split('.');
        const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        return integerPart + ',' + parts[1] + ' zł';
    }

    function generateTableRow(apartment) {
        const pricingTransparencyEnabled = $('#apartments-search-result-container').data('pricing-transparency-enabled') === true ||
                                           $('#apartments-search-result-container').attr('data-pricing-transparency-enabled') === 'true';

        const now = new Date();
        const promoActiveFrom = apartment.promoActiveFrom ? new Date(apartment.promoActiveFrom) : null;
        const isPromo = apartment.promoActive === true && (!promoActiveFrom || promoActiveFrom <= now);

        let priceGrossCell = '';
        let pricePerM2Cell = '';

        if (pricingTransparencyEnabled) {
            if (isPromo) {
                priceGrossCell = `
                    <div class="price-with-promo">
                        <span class="promo-price nowrap">${apartment.promoPriceGross ? formatPrice(apartment.promoPriceGross) : '-'}</span>
                        <del class="old-price nowrap">${apartment.priceGross ? formatPrice(apartment.priceGross) : '-'}</del>
                    </div>
                `;
                pricePerM2Cell = `
                    <div class="price-with-promo">
                        <span class="promo-price nowrap">${apartment.promoPricePerM2Gross ? formatPrice(apartment.promoPricePerM2Gross) : '-'}</span>
                        <del class="old-price nowrap">${apartment.pricePerM2Gross ? formatPrice(apartment.pricePerM2Gross) : '-'}</del>
                    </div>
                `;
            } else {
                priceGrossCell = `<span class="regular-price nowrap">${apartment.priceGross ? formatPrice(apartment.priceGross) : '-'}</span>`;
                pricePerM2Cell = `<span class="regular-price nowrap">${apartment.pricePerM2Gross ? formatPrice(apartment.pricePerM2Gross) : '-'}</span>`;
            }
        }

        return `
            <tr data-href="${apartment.url || ''}" class="apartment-status status-${apartment.status['id'] || '0'}">
                <td class="no-transform">${apartment.building || ''}</td>
                <td class="no-transform">${apartment.name || ''}</td>
                <td>${apartment.status['label'] || ''}</td>
                <td>${apartment.type || ''}</td>
                <td>${apartment.area || ''}</td>
                <td>${apartment.floor || ''}</td>
                <td>${apartment.rooms || ''}</td>
                ${pricingTransparencyEnabled ? `<td>${priceGrossCell}</td>` : ''}
                ${pricingTransparencyEnabled ? `<td>${pricePerM2Cell}</td>` : ''}
                <td>${apartment.sides.map((side, i) => `${side}${(apartment.sides.length === i + 1) ? '' : ', '}`).join('')}</td>
                <td><span>${apartment.amenities.loggia || '-'}</span><!--
                 --><span>${apartment.amenities.terrace || '-'}</span></td>
                <td class="floor-plan">
                    ${apartment.photo_url ? `
                        <a href="${apartment.photo_url}" target="_blank"><i class="fas fa-search"></i></a>
                        <div class="floor-plan__preview">
                            <img src="${apartment.photo_url}" alt="${apartment.name || ''}" />
                        </div>
                    ` : ''}
                </td>
            </tr>
        `;
    }

    function generateTable(apartmentData, append = false) {
        const markup = apartmentData.map(apartment => generateTableRow(apartment)).join('');

        if (append) {
            $('#apartments-search-result-container table tbody').append(markup);
        } else {
            $('#apartments-search-result-container table tbody').html(markup);
        }
    }

    function updateLoadMoreButton(pages, totalLoaded) {
        const loadMoreContainer = $('#apartments-search-result-container .apartments-load-more');
        const totalCount = pages.total * 10;
        const remaining = totalCount - totalLoaded;

        if (remaining > 0 && pages.next_page) {
            if (loadMoreContainer.length === 0) {
                $('#apartments-search-result-container').append(`
                    <div class="apartments-load-more">
                        <button class="btn btn-transparent apartments-load-more__btn" data-page="${pages.next_page}">
                            Załaduj więcej
                        </button>
                    </div>
                `);
            } else {
                loadMoreContainer.find('.apartments-load-more__btn').attr('data-page', pages.next_page);
                loadMoreContainer.show();
            }
        } else {
            loadMoreContainer.hide();
        }
    }

    // Horizontal scroll indicator
    function initScrollIndicator() {
        const tableWrapper = document.querySelector('.apartments-table-wrapper');
        const thumb = document.querySelector('.apartments-scroll-indicator__thumb');
        const track = document.querySelector('.apartments-scroll-indicator__track');

        if (!tableWrapper || !thumb || !track) return;

        function updateScrollIndicator() {
            const scrollLeft = tableWrapper.scrollLeft;
            const scrollWidth = tableWrapper.scrollWidth - tableWrapper.clientWidth;
            const trackWidth = track.offsetWidth;
            const thumbWidth = thumb.offsetWidth;

            if (scrollWidth > 0) {
                const scrollPercent = scrollLeft / scrollWidth;
                const maxLeft = trackWidth - thumbWidth;
                thumb.style.left = (scrollPercent * maxLeft) + 'px';
            }
        }

        tableWrapper.addEventListener('scroll', updateScrollIndicator);
        window.addEventListener('resize', updateScrollIndicator);
        updateScrollIndicator();

        // Make thumb draggable
        let isDragging = false;
        let startX, startLeft;

        thumb.addEventListener('mousedown', (e) => {
            isDragging = true;
            startX = e.clientX;
            startLeft = thumb.offsetLeft;
            thumb.style.cursor = 'grabbing';
        });

        document.addEventListener('mousemove', (e) => {
            if (!isDragging) return;
            const deltaX = e.clientX - startX;
            const trackWidth = track.offsetWidth;
            const thumbWidth = thumb.offsetWidth;
            const maxLeft = trackWidth - thumbWidth;
            const newLeft = Math.max(0, Math.min(maxLeft, startLeft + deltaX));

            thumb.style.left = newLeft + 'px';

            const scrollPercent = newLeft / maxLeft;
            const scrollWidth = tableWrapper.scrollWidth - tableWrapper.clientWidth;
            tableWrapper.scrollLeft = scrollPercent * scrollWidth;
        });

        document.addEventListener('mouseup', () => {
            isDragging = false;
            thumb.style.cursor = 'grab';
        });

        thumb.style.cursor = 'grab';
    }

    initScrollIndicator();

    $(apartmentSearchForm).submit(function(event) {
        event.preventDefault();

        if (isLoadingMore) return;

        let formData = $(apartmentSearchForm).serialize();

        $.ajax({
            type: $(apartmentSearchForm).attr('method') ? $(apartmentSearchForm).attr('method') : 'GET',
            url: $(apartmentSearchForm).attr('action'),
            data: formData,
            beforeSend: function() {
                $(apartmentSearchResultsContainer).addClass('loading');
            }
        }).done(function(response) {

            $(apartmentSearchResultsContainer).removeClass('loading');

            generateTable(response.data, false);
            updateLoadMoreButton(response.pages, response.data.length);
            $(apartmentSearchResultsContainer).data('loaded-count', response.data.length);

            if ($(window).scrollTop() > $(apartmentSearchResultsContainer).offset().top) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(apartmentSearchResultsContainer).offset().top - scrollOffset
                }, 300);
            }

            initScrollIndicator();

            if (fbq) {
                fbq('track', 'Search');
            }

        }).fail(function(response) {
            $(apartmentSearchResultsContainer).removeClass('loading');
            alert(response);
        });

    });

    // Load more click handler
    $(document).on('click', '.apartments-load-more__btn', function(e) {
        e.preventDefault();
        if (isLoadingMore) return;

        const page = $(this).data('page');
        isLoadingMore = true;

        const $btn = $(this);
        $btn.addClass('loading').prop('disabled', true);

        let formData = $(apartmentSearchForm).serialize();
        formData = formData.replace(/page=\d+/, 'page=' + page);
        if (formData.indexOf('page=') === -1) {
            formData += '&page=' + page;
        }

        $.ajax({
            type: $(apartmentSearchForm).attr('method') ? $(apartmentSearchForm).attr('method') : 'GET',
            url: $(apartmentSearchForm).attr('action'),
            data: formData
        }).done(function(response) {
            generateTable(response.data, true);

            const currentLoaded = parseInt($(apartmentSearchResultsContainer).data('loaded-count')) || 0;
            const newLoaded = currentLoaded + response.data.length;
            $(apartmentSearchResultsContainer).data('loaded-count', newLoaded);

            updateLoadMoreButton(response.pages, newLoaded);
        }).fail(function(response) {
            alert(response);
        }).always(function() {
            isLoadingMore = false;
            $btn.removeClass('loading').prop('disabled', false);
        });
    });

    let timer;
    function submitSearchApartmentsForm(timeout, page=1) {
        if (timer) { clearTimeout(timer); }
        timer = setTimeout(function() {
            $('#apartment-search-page').val(page);
            $(apartmentSearchForm).submit();
        }, timeout);

    }
    //submit on input change
    $('#apartments-search-form input, #apartments-search-form select').change(function() {
        submitSearchApartmentsForm(1000);
    });
    //submit on input edit
    $('#apartments-search-form input').on('input', function() {
        submitSearchApartmentsForm(2500);
    });



    //redirection on elements with data-href attribute
    $('body').on('click', '*[data-href]', function(){
        window.location = $(this).data('href');
        return false;
    });

    //scroll on elements with href hash
    $('a[href*=\\#]').on('click', function(e){

        if (!$(this).data('page')) {

            let href = $(this).attr('href');
            var hash = href.substr(href.indexOf('#')+1);

            if (hash && $('#'+hash).length) {
                let position = $('#'+hash).position();

                if (position && position.top) {

                    e.preventDefault();

                    $('html, body')
                        .animate(
                            {scrollTop: position.top - scrollOffset},
                            500,
                            'swing',
                            function () {
                            }
                        );

                }
            }

        }
    });


    //scroll on elements with data-scroll attribute
    $('*[data-scroll]').on('click', function(e){
        e.preventDefault();

        let element = $(this).data('scroll');

        if ($('#' + element).length) {
            let position = $('#' + element).position();

            if (position && position.top) {

                $('html, body')
                    .animate(
                        {scrollTop: position.top - scrollOffset},
                        500,
                        'swing',
                        function () {
                        }
                    );

            }
        }
    });



    //floorChoser hover & click
    $('.floor-chooser-pp svg > *').on('mouseenter', function(){
        let id = $(this).data('rel');
        $('.tooltip.'+id).addClass('visible');
    }).on('mouseleave', function(){
        let id = $(this).data('rel');
        $('.tooltip.'+id).removeClass('visible');
    }).on('click', function(){
        let building = $(this).data('building');
        let floor = $(this).data('floor');

        if (building && floor) {
            $('#search-building').val(building);
            $('#search-floor-from').val(floor);
            $('#search-floor-to').val(floor);
        }

        if ($(apartmentSearchForm).length) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(apartmentSearchForm).offset().top - scrollOffset
            }, 300);
        }

        if ($(apartmentSearchForm).length) {
            $(apartmentSearchForm).trigger('submit');
        }

    });

    //hide menu on click outside
    const outsideClickListener = (event) => {
        let selector = '.main-header.header';
        let target = $(event.target);

        if (!target.closest(selector).length && $(selector).hasClass('opened')) {
            $(selector).removeClass('opened');
            document.removeEventListener('click', outsideClickListener);
        }
    };

    //open menu on mobile
    if ($( window ).width() < 768) {
        let headerElement = $('.main-header.header');
        headerElement.on('click', '.header__menu', function(){

            if (headerElement.hasClass('opened')) {
                document.removeEventListener('click', outsideClickListener);
            } else {
                document.addEventListener('click', outsideClickListener);
            }

            headerElement.toggleClass('opened');

        });
    }


    //additional fb pixel events
    $('.tracked-email').on('click', function(){
        if (fbq) {
            fbq('track', 'Lead');
        }
    });

    // Initialize Bootstrap carousel
    initCarousel();

});

// Initialize Bootstrap carousel
function initCarousel() {
    $('.carousel').each(function() {
        const $carousel = $(this);
        const $items = $carousel.find('.item');
        
        if ($items.length <= 1) {
            return; // No need to initialize if only one or no items
        }
        
        let currentIndex = 0;
        const totalItems = $items.length;
        
        // Find active item
        $items.each(function(index) {
            if ($(this).hasClass('active')) {
                currentIndex = index;
            }
        });
        
        // Auto-rotate carousel
        const autoRotate = function() {
            $items.removeClass('active');
            $carousel.find('.carousel-indicators li').removeClass('active');
            
            currentIndex = (currentIndex + 1) % totalItems;
            
            $items.eq(currentIndex).addClass('active');
            $carousel.find('.carousel-indicators li').eq(currentIndex).addClass('active');
        };
        
        // Set interval for auto-rotation (5 seconds)
        let carouselInterval = setInterval(autoRotate, 5000);
        
        // Pause on hover
        $carousel.on('mouseenter', function() {
            clearInterval(carouselInterval);
        }).on('mouseleave', function() {
            carouselInterval = setInterval(autoRotate, 5000);
        });
        
        // Handle indicator clicks
        $carousel.find('.carousel-indicators li').on('click', function() {
            const index = $(this).data('slide-to');
            if (typeof index !== 'undefined') {
                clearInterval(carouselInterval);
                $items.removeClass('active');
                $carousel.find('.carousel-indicators li').removeClass('active');
                currentIndex = index;
                $items.eq(currentIndex).addClass('active');
                $(this).addClass('active');
                carouselInterval = setInterval(autoRotate, 5000);
            }
        });
        
        // Handle prev/next controls
        $carousel.find('.carousel-control').on('click', function(e) {
            e.preventDefault();
            clearInterval(carouselInterval);
            
            const isNext = $(this).hasClass('right') || $(this).data('slide') === 'next';
            
            $items.removeClass('active');
            $carousel.find('.carousel-indicators li').removeClass('active');
            
            if (isNext) {
                currentIndex = (currentIndex + 1) % totalItems;
            } else {
                currentIndex = (currentIndex - 1 + totalItems) % totalItems;
            }
            
            $items.eq(currentIndex).addClass('active');
            $carousel.find('.carousel-indicators li').eq(currentIndex).addClass('active');
            
            carouselInterval = setInterval(autoRotate, 5000);
        });
    });
}
